// Author NYA
// Date 2020-11-10 11:33:21

class SithMesPrdStopWorkType {
constructor({
        id = null,
        parentId = '',
        name = '',
        remark = ''}
= {}) {
    this.id = id;
    this.parentId = parentId;
    this.name = name;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdStopWorkType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'parentId',
        label: 'label.sith.prd.sithMesPrdStopWorkType.grid.parentId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdStopWorkType.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.sith.prd.sithMesPrdStopWorkType.grid.level',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.sith.prd.sithMesPrdStopWorkType.grid.nodeCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.sith.prd.sithMesPrdStopWorkType.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdStopWorkType.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    parentIdFilter : "",
    nameFilter : "",
    levelFilter : "",
    nodeCodeFilter : "",
    seqFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'parentIdFilter',
        label: 'label.sith.prd.sithMesPrdStopWorkType.filter.parentId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.prd.sithMesPrdStopWorkType.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'levelFilter',
        label: 'label.sith.prd.sithMesPrdStopWorkType.filter.level',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nodeCodeFilter',
        label: 'label.sith.prd.sithMesPrdStopWorkType.filter.nodeCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.sith.prd.sithMesPrdStopWorkType.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'parentId',
        label: 'label.sith.prd.sithMesPrdStopWorkType.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdStopWorkType.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdStopWorkType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdStopWorkType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
